<template>
  <div>
    <Title
      :title-text="$t('login_patientAccountTitle_text')"
      :text="`${$t('common_loginAccount_placeholder')}?`"
      :link-text="$t('login_registerLink_text')"
      route="register"
      data-qa="por-login--title" />
    <LoginForm data-qa="por-login--form" />
  </div>
</template>

<script>
import Title from '@/components/title'
import LoginForm from '@/components/forms/login'
import { track } from '@/services/tracking'

export default {
  name: 'Login',
  components: {
    Title,
    LoginForm
  },
  mounted () {
    track({ name: 'page view', params: { module: 'login' } })
  }
}
</script>
